// Canvas 畫布操作相關的提示信息
export default {
  deleteNodeFailed: "刪除失敗，請刷新頁面重新操作！",
  operationFailed: "操作失敗，請刷新頁面重新操作！",
  nodeRepeatWarning: "此節點在畫布中重複出現{count}次!",
  noMoreNodes: "已無更多節點！",
  doubleClickViewTransaction: "雙擊查看交易詳情",
  addressOwnership: "這是地址歸屬",
};
